module.exports = __webpack_public_path__ + "media/src/ui/icons/bigIconUpload-27ed711b175a6ea541c394844468f230.svg";